"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveLocalization = void 0;
const cookie_1 = require("../cookie");
const constants_1 = require("./constants");
const resolveLocalization = (additionalResolver) => {
    return (getLocaleFromSearchString() ||
        getLocaleFromCookies() ||
        getLocaleFromBrowser() ||
        additionalResolver?.() ||
        constants_1.LOCALIZATION_FALLBACK);
};
exports.resolveLocalization = resolveLocalization;
const getLocaleFromSearchString = () => {
    const url = window.location.href;
    const urlParams = new URLSearchParams(new URL(url).search);
    return urlParams.get(constants_1.SEARCH_STRING_LOCALIZATION_KEY);
};
const getLocaleFromCookies = () => (0, cookie_1.getCookie)(constants_1.COOKIE_USER_CULTURE_KEY);
const getLocaleFromBrowser = () => navigator.language;
